import React from "react";
import DropDownFilterDates from "./DropDownFilterDate";

export const CardAnalytics = ({ children, title = "empty", bottomText = "", filter = true, callbackDate = () => { } }) => {
    return (
        <div className="w-full xl:w-1/2 h-[234px] 2xl:h-[300px] p-3">
            <div className='rounded-2xl bg-white shadow-xl h-full w-full'>
                <div className="flex w-full h-2/6 pt-5 px-4 ">
                    <div className={filter ? `w-7/12` : `w-11/12`}>
                        <p className="font-normal text-base text-[#686868]">{title}</p>
                    </div>
                    {
                        filter &&
                        <div className="w-5/12 flex justify-end">
                            <div>
                                <DropDownFilterDates callBack={callbackDate}></DropDownFilterDates>
                            </div>
                        </div>
                    }
                </div>
                <div className="w-full h-3/6">
                    {children}
                </div>
                {
                    bottomText !== "" &&
                    <div className="">
                            {/* <img src={icons.arrowGreenUp} className="w-4 mr-1" alt="" /> */}
                            {/* <p className="font-normal text-md text-[#9A9A9A]">{bottomText}</p> */}
                    </div>
                }
            </div>
        </div>
    )
}

export default CardAnalytics;
